export const setUomData = payload => ({
	type: "SET_UOM_DATA",
	payload
});